"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawerItem = void 0;
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const Collapse_1 = __importDefault(require("@material-ui/core/Collapse"));
const ListItem_1 = __importDefault(require("@material-ui/core/ListItem"));
const ListItemIcon_1 = __importDefault(require("@material-ui/core/ListItemIcon"));
const ListItemText_1 = __importDefault(require("@material-ui/core/ListItemText"));
const ExpandLess_1 = __importDefault(require("@material-ui/icons/ExpandLess"));
const ExpandMore_1 = __importDefault(require("@material-ui/icons/ExpandMore"));
const drawer_context_1 = require("./drawer-context");
const drawer_styles_1 = require("./drawer-styles");
const drawer_utils_1 = require("./drawer-utils");
function DrawerItem({ item, level }) {
    var _a, _b;
    const classes = (0, drawer_styles_1.useStyles)();
    const { handleCollapseState, collapseState, setOpen } = (0, react_1.useContext)(drawer_context_1.DrawerContext);
    const { pathname } = (0, react_router_dom_1.useLocation)();
    const id = (0, drawer_utils_1.getIdForMenuItem)(item);
    if (!id) {
        return null;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(ListItem_1.default, { dense: true, button: true, onClick: () => {
                handleCollapseState(id);
                if (item.onClick) {
                    item.onClick();
                    // close drawer after click
                    setOpen(false);
                }
            }, style: {
                paddingLeft: item.subHeader ? level - 0.5 + 'rem' : level + 'rem',
                background: ((_a = item.isActive) === null || _a === void 0 ? void 0 : _a.call(item, pathname)) ? '#e7e7e7' : 'none',
            } },
            item.icon && react_1.default.createElement(ListItemIcon_1.default, null, item.icon),
            react_1.default.createElement(ListItemText_1.default, { primary: item.label, style: {
                    fontWeight: item.subHeader ? 'bold !important' : 'normal',
                }, classes: {
                    primary: classes.drawerTitle,
                } }),
            collapseState[id] === true && react_1.default.createElement(ExpandLess_1.default, null),
            collapseState[id] === false && react_1.default.createElement(ExpandMore_1.default, null)),
        ((_b = item.items) === null || _b === void 0 ? void 0 : _b.length) && (react_1.default.createElement(Collapse_1.default, { in: collapseState[id], timeout: "auto", unmountOnExit: true }, item.items.map((subItem, i) => (react_1.default.createElement(DrawerItem, { key: i, item: subItem, level: level + 1 })))))));
}
exports.DrawerItem = DrawerItem;
//# sourceMappingURL=drawer-item.js.map